const primary = ['#1A365D', '#1D4394', '#055EC2', '#045B62', '#FF5900', '#27AA6D', '#CD1E82', '#8080D6', "#F52D1F", '#6D6D6D', "#FFFFFF"];
const secondary = ['#4097CA', '#12D55B', '#F48B57', '#B0AEEA', '#FF695F', '#B1B1B1'];

export { primary, secondary }